import { render, staticRenderFns } from "./DialogForgotPsd-v2.vue?vue&type=template&id=6fd7474e"
import script from "./DialogForgotPsd-v2.vue?vue&type=script&lang=js"
export * from "./DialogForgotPsd-v2.vue?vue&type=script&lang=js"
import style0 from "./DialogForgotPsd-v2.vue?vue&type=style&index=0&id=6fd7474e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports